class Article
    constructor: (el) ->
        @.$el = el
        @.$articleHeaderEl = @.$el.querySelector '.article__header'
        @.$articleRichtext = @.$el.querySelector '.article__text'

        @.rtCalculated = @.$el.classList.contains 'article--rt-calculated'

        if !@.rtCalculated
            @.CalculateReadingTime()
        @.$el.classList.add 'article--bound'
        return

    CalculateReadingTime: ->
        wpm = @.$articleHeaderEl?.dataset?.rtwpm ? 225
        wpm = if wpm > 0 then wpm else 1
        words = @.$articleRichtext.innerText.trim().split(/\s+/).length
        time = Math.ceil words / wpm
        @.$articleHeaderEl.dispatchEvent new CustomEvent 'article-header-set-reading-time', {
            bubbles: false
            detail: {
                readingTime: time
            }
        }
        @.$el.classList.add 'article--rt-calculated'
        return

BindArticles = ->
    document.querySelectorAll '.article:not(.article--bound)'
        .forEach (el) ->
            new Article el
            return
    return

window.addEventListener 'bind-components', BindArticles